import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { HOSummaryEmployeeRequestService } from "../../../../../services/human-organization/summary-employee-request.service";

export const useGetMyApprovals = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["summary-employee-request", currentUserName],
    queryFn: () =>
    HOSummaryEmployeeRequestService.getSummaryEmployeeRequests(currentUserName, ""),
    refetchOnMount:"always"
  });

  return response;
};
